// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-LoginHeader_cls1__9JQz6","cls2":"StyledComponents-LoginHeader_cls2__z33Qv StyledComponents-LoginHeader_cls1__9JQz6"};